import { useLocation } from '@reach/router'

const useModule: () => [boolean] = () => {
  const loc = useLocation()
  const isMonitor = loc.pathname.startsWith('/monitor/')

  return [isMonitor]
}

export default useModule
